import React, { Fragment } from "react";
import { NextButton, PrevButton } from "../../navigation/components/Buttons";

const ParentObjectNavigation = ({ history, section, obj }) => {
  return (
    <Fragment>
      {obj.PREV && (
        <PrevButton
          onClick={() =>
            history.push(
              `${process.env.REACT_APP_URL_PATH}/view/${obj.PREV[0]}/${section}`
            )
          }
        />
      )}
      {obj.NEXT && (
        <NextButton
          onClick={() =>
            history.push(
              `${process.env.REACT_APP_URL_PATH}/view/${obj.NEXT[0]}/${section}`
            )
          }
        />
      )}
    </Fragment>
  );
};

export default ParentObjectNavigation;
